<template>
  <img :src="safeSrc" :alt="alt" />
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: false,
      default: 'img',
    },
    nocache: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      safeSrc: 'https://placeimg.com/1022/994/any',
    }
  },
  beforeMount() {
    try {
      let source = this.src
      if (!this.src.startsWith('/')) {
        source = '/' + source
      }

      this.safeSrc = require('@assets/images' + source)

      // disable cache
      if (this.nocache) this.safeSrc += '?t=' + Date.now()
    } catch (e) {
      this.$log.warn('unsafe image url : ', this.src)
    }
  },
}
</script>
